import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <img src="/valbrac-logo.png" alt="Valbrac" className="h-11 w-11 rounded-xl bg-white p-1 shadow" />
          <div>
            <p className="text-lg font-extrabold text-[#0B2545]">VALBRAC</p>
            <p className="text-xs font-medium uppercase tracking-widest text-emerald-600">Portal SSMA</p>
          </div>
        </div>
        {sent ? (
          <div className="rounded-xl border border-[#E2E8F0] bg-white p-6 text-center shadow-sm" data-testid="forgot-success">
            <MailCheck className="mx-auto mb-3 h-10 w-10 text-emerald-500" />
            <h2 className="text-lg font-bold text-[#0B2545]">Verifique seu e-mail</h2>
            <p className="mt-2 text-sm text-slate-500">
              Se este e-mail estiver cadastrado, um link de redefinição foi enviado. O link expira em 1 hora.
            </p>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-[#0B2545]">Recuperar senha</h2>
            <p className="mt-1 text-sm text-slate-500">Informe seu e-mail para receber o link de redefinição</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <Label className="mb-1.5 block text-sm font-medium text-slate-700">E-mail</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  required className="h-11 bg-white" data-testid="forgot-email" />
              </div>
              {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</p>}
              <Button type="submit" disabled={loading} className="h-11 w-full bg-[#0B2545] hover:bg-[#134074]" data-testid="forgot-submit">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Enviar link"}
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-[#134074] hover:underline">
          <ArrowLeft className="h-4 w-4" /> Voltar para o login
        </Link>
      </div>
    </div>
  );
}
